<template>
    <div class="UsedMPNsTableComponent  DataTables">
        <p>{{ lang.infotext_1 }}:</p>
        <div :id="id">
            <LoaderComponent v-if="!isData"></LoaderComponent>
        </div>
        <!-- <ContextMenuComponent v-if="isPlugin" :menu="menuPlugin" :id="name"></ContextMenuComponent>
        <ContextMenuComponent v-if="!isPlugin" :menu="menu" :id="name"></ContextMenuComponent> -->
        <br>
    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '@/Tools/Tools';
import dt from 'datatables.net-bs4';





require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"
import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import { mapGetters } from 'vuex'
export default {
    name: 'UsedMPNsTableComponent',
    props: {
        lang: Object
    },
    components: {
        LoaderComponent,
        ContextMenuComponent

    },
    data() {
        return {
            name: "UsedMPNsTableComponent",
            id: "tableplace_" + this._uid,
            columns: [],
            colsAssign: [],
            activeActionIds: [],
            contextMenu: {},
            //list of items in the context menu:
            menu: [
                { id: "Details", text: this.lang.contextmenu_text_Details },
                //{id: "Derive", text: this.lang.contextmenu_text_Derive},
                //{id: "Withdraw", text: this.lang.contextmenu_text_Withdraw},
            ],
            menuPlugin: [
                { id: "Place", text: this.lang.contextmenu_text_Place },
                { id: "Derive", text: this.lang.contextmenu_text_Derive },

            ],
            visibility: ["NotExposed", "ExposedToTables", "TransferredToDesign", "ForceDisplayed", "ForceHidden"],
            lengthMenu: 20,
        }
    },
    computed: {
        ...mapGetters({

            isPlugin: "isPlugin"

        }),
        
        isData() {

            return false
        },
        reloadedAfterAction() {
            return this.$store.getters.reloadedAfterAction;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        }

    },
    created() {
        
    },
    watch: {
        
        
        reloadedAfterAction: function (newValue, oldValue) {


            if (newValue.name == this.name) {
                if (newValue.status == true) {

                    this.buildColumns()

                    newValue.status = false;
                    newValue.name = "";
                    this.$store.dispatch("reloadAfterAction", newValue);
                }
            }

        }

    },
    updated() {

    },
    mounted: function () {

        this.buildColumns()


    },
    methods: {
        
        buildColumns() {
            this.columns = [
                {
                    name: "DistributorPartId",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "ImageUrl",
                    alignInColumn: "left",
                    type: "image"
                },
                {
                    name: "DistributorName",
                    alignInColumn: "left",
                    type: "badges"
                },
                {
                    name: "DistributorPartNumber",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "DistributorKey",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "ManufacturerName",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "ManufacturerPartNumber",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "Description",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "DtasheetUrl",
                    alignInColumn: "left",
                    type: "link"
                },
                {
                    name: "IsROHSCompliant",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "ProductDetailUrl",
                    alignInColumn: "left",
                    type: "link"
                },
                {
                    name: "AvailableQuantity",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "LeadDays",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "LifecycleStatus",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "EOL",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: "EOS",
                    alignInColumn: "left",
                    type: "text"
                },
                // {
                //     name: "TempMin",
                //     alignInColumn: "left",
                //     type: "text"
                // },
                // {
                //     name: "TempMax",
                //     alignInColumn: "left",
                //     type: "text"
                // },

            ];

            this.colsAssign = [
               { "data": "col___DistributorPartId" },
                { "data": "col___ImageUrl" },
                { "data": "col___DistributorName" },
                { "data": "col___DistributorPartNumber" },
                { "data": "col___DistributorKey" },
                { "data": "col___ManufacturerName" },
                { "data": "col___ManufacturerPartNumber" },
                { "data": "col___Description" },
                { "data": "col___DtasheetUrl" },
                { "data": "col___IsROHSCompliant" },
                { "data": "col___ProductDetailUrl" },
                { "data": "col___AvailableQuantity" },
                { "data": "col___LeadDays" },
                { "data": "col___LifecycleStatus" },
                { "data": "col___EOL" },
                { "data": "col___EOS" },
                // { "data": "col___TempMin" },
                // { "data": "col___TempMax" },

            ]

            

            this.buildTable();
        },

        checkEndOfDate(date) {
            const now = new Date();
            const oneDay = 1000 * 60 * 60 * 24;

            if (date != null || date == '') {
                const endoflifeDate = new Date(date)
                const diffInTimeA = endoflifeDate.getTime() - now.getTime();
                const diffInDaysA = Math.round(diffInTimeA / oneDay);

                if (diffInDaysA < 365) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false
            }
        },
        buildTable() {


            //let lengthMenu = 20;



            // if (this.$store.getters.outerData != true) {

            //     this.$store.dispatch("deleteAllSelectedRows");
            //     this.$store.dispatch("setOuterData", false);
            // }

            var tableplace = document.getElementById("tableplace_" + this._uid);
            if (tableplace == null) {
                return;
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var place = document.createElement("table");
            place.setAttribute("id", "place" + this._uid);
            place.setAttribute("class", "table table-striped table-bordered");
            place.setAttribute("style", "width:100%;");
            tableplace.appendChild(place)

            var tr1 = document.createElement("tr");
            tr1.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr1);
            place.appendChild(thead);

            var tr2 = document.createElement("tr");
            tr2.setAttribute("class", "cellFooter");
            var tfoot = document.createElement("tfoot");
            tfoot.appendChild(tr2);
            place.appendChild(tfoot);



            var columnDefs = [];


            let _vue = this;

            var len = this.columns.length;

            let y = 0;

            for (let i = 0; i < len; i++) {

                let el = {
                    targets: i,
                    className: '_dt-body-' + _vue.columns[i].alignInColumn,
                    render: function (data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.value.display != undefined) {
                            data.value.display = $.fn.dataTable.render.text().display(data.value.display);
                        }

                        if (meta.settings.oInit.myColumnFormats[meta.col].type == "image") {
                            
                            if ((data.value.display != null) && (data.value.display != "") && ((data.value.display.indexOf("http://") != -1) || (data.value.display.indexOf("https://") != -1))) {

                                return "<img class=\"image\" height='40px' src='" + data.value.display + "'>";
                            }
                            return "<img class=\"imageSVG\" height='40px' src='/static/part.png'>";
                        } else if (meta.settings.oInit.myColumnFormats[meta.col].type == "link") {


                            if (data.value.display.length != 0) {
                                
                                let pos = data.value.display.indexOf("http");
                                if (pos > -1) {
                                    return "<a href='" + data.value.display + "' target='_blank'>Link</a>";
                                } else {
                                    return data.value.display;
                                }

                            } else {
                                return "";
                            }


                            return "";
                        } else if (meta.settings.oInit.myColumnFormats[meta.col].type == "checkbox") {
                            let accepted = true
                            let checked = ""
                            let str = "<div class=\"custom-control custom-checkbox\"><input " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm select-alternative\" id=\"select_" + data.value.display + "\" value=\"" + accepted + "\"></div>";

                            return str;
                        }

                        if (meta.col == 14 || meta.col == 15) {

                            if (data.value.display == null || data.value.display == '') {
                                return "";
                            } else {
                                if (vue.checkEndOfDate(data.value.display) == true) {
                                    return "<b-badge class='badge badge-danger '>" + Tools.longDateToShort(data.value.display, false) + "</b-badge>";
                                } else {
                                    return Tools.longDateToShort(data.value.display, false);
                                }
                            }
                        }


                        


                        return data.value.display;



                    }
                }



                columnDefs.push(el);




                var th1 = document.createElement("th");

                tr1.appendChild(th1);

                var br = document.createElement("br");
                var tx = document.createTextNode(this.columns[i].name);
                th1.appendChild(br);
                th1.appendChild(tx);

            }

            let vue = this;


            var option = {};


            option.keys = false;
            //json.data= datatable;
            option.myColumnFormats = this.columns;
            option.colReorder = false;
            option.lengthMenu = [[20, -1], [20, "All"]];
            option.order = [[5, "asc"]];
            option.select = true;
            option.columns = this.colsAssign;
            option.columnDefs = columnDefs;
            if (this.isPlugin) {
                option.dom = '<flr<t>ip>';
            } else {
                option.dom = '<fBlr<t>ip>';
            }

            option.processing = true;
            option.serverSide = true;
            // option.search = {
            //   regex: true
            // }
            option.initComplete = function (settings, json) {


                this.api().columns().every(function () {
                    var column = this;

                    if (vue.columns[column[0][0]].type != "image") {
                        var select = $('<select><option value=""></option></select>')
                            .appendTo($(column.footer()).empty())
                            .on('change', function () {

                                var val = $.fn.dataTable.util.escapeRegex(
                                    $(this).val()
                                );

                                column
                                    .search(val ? val : '', true, false)
                                    .draw();
                            });
                        let arr = [];
                        column.data().unique().sort().each(function (d, j) {
                            if (d == null) {
                                return
                            }

                            if (d.value.display != null) {

                                //if (!arr.includes(d.value.display)){
                                arr.push(d.value.display);
                                select.append('<option value="' + d.value.display + '">' + d.value.display + '</option>');
                                //}

                            }


                        });
                    }

                });



            }
            option.fnDrawCallback = function (oSettings) {

                //vue.buildContextMenu();
            }
            option.buttons = [
                {
                    extend: 'copy',
                    className: 'btn-' + vue.variant,
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: 'print',
                    className: 'btn-' + vue.variant,
                    messageTop: function () {
                        return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeProjectItemObject.category;
                    },
                    exportOptions: {
                        columns: ':visible'
                    },
                    autoPrint: true,
                    style: 'fullWidth',

                    customize: function (win) {
                        $(win.document.body)
                            .css('font-size', '10pt')


                        $(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                },
                {
                    extend: 'csv',
                    className: 'btn-' + vue.variant,
                    exportOptions: {
                        columns: ':visible'
                    },
                },
                {
                    extend: 'excel',
                    exportOptions: {
                        columns: ':visible'
                    },
                    className: 'btn-' + vue.variant,
                    customize: function (xlsx) {

                        var sheet = xlsx.xl.worksheets['Parts.xml'];


                    }
                },
                {
                    extend: 'pdfHtml5',
                    messageTop: function () {
                        return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeProjectItemObject.category;
                    },
                    className: 'btn-' + vue.variant,
                    exportOptions: {
                        columns: ':visible'
                    },
                    orientation: 'landscape',
                    pageSize: 'A4',
                    download: 'open',

                    styles: {
                        fullWidth: {
                            fontSize: 3,
                            bold: true,
                            alignment: 'right',
                            margin: [0, 1900, 0, 80]
                        },
                        subheader: {
                            fontSize: 4
                        },
                        superMargin: {
                            margin: [20, 0, 40, 0],
                            fontSize: 5,
                        }
                    },
                    customize: function (doc) {


                        doc.pageMargins = [10, 10, 10, 10];

                        doc.styles.title.fontSize = 9;
                        doc.defaultStyle.fontSize = 7;
                        doc.styles.tableHeader.fontSize = 9;
                        doc.content[0].text = doc.content[0].text.trim();

                        let numberOfHeaders = columnDefs.length;

                        if ((numberOfHeaders > 10) && (numberOfHeaders < 15)) {

                            doc.defaultStyle.fontSize = 5;
                            doc.styles.tableHeader.fontSize = 7;
                        } else if ((numberOfHeaders >= 15) && (numberOfHeaders < 18)) {

                            doc.defaultStyle.fontSize = 5;
                            doc.styles.tableHeader.fontSize = 7;
                        } else if (numberOfHeaders >= 18) {

                            doc.defaultStyle.fontSize = 3;
                            doc.styles.tableHeader.fontSize = 5;
                        }

                    },

                },
                {
                    text: 'Json',
                    exportOptions: {
                        columns: ':visible'
                    },
                    className: 'btn-' + vue.variant,
                    action: function (e, dt, button, config) {
                        var data = dt.buttons.exportData();

                        $.fn.dataTable.fileSave(
                            new Blob([JSON.stringify(data)]),
                            'Libraries.json'
                        );
                    }
                },
                {
                    text: 'Reload',
                    exportOptions: {
                        columns: ':visible'
                    },
                    className: 'btn-' + vue.variant,
                    action: function (e, dt, button, config) {

                        vue.mainTable.ajax.reload();
                    }

                },
                {
                    extend: 'colvis',
                    className: 'btn-' + vue.variant,

                },
            ];

            option.ajax = {
                url: /*this.server + */"/api/v3/partmanagement/parts/GetUsedMPNs",

                crossDomain: true,
                type: 'POST',
                dataType: 'json',
                cors: true,
                contentType: 'application/json',
                secure: false,
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    // console.log(xhr)
                    // console.log(xhr.status)
                    // console.log(thrownError)
                    if (xhr.responseJSON.message == "Authorization failure.") {

                        vue.$store.dispatch("logout");
                    }

                },
                data: function (json) {

                  

                    for (let i = 0, lei = json.columns.length; i < lei; i++) {
                        json.columns[i].col = i;
                    }

                    

                    return JSON.stringify(json);
                },
                dataFilter: function (data) {
                    //todo 

                    // if (vue.$store.getters.outerData != true) {
                    //     vue.$store.dispatch("deleteAllSelectedRows");
                    //     vue.$store.dispatch("setOuterData", false);
                    // }
                    y = 0;
                    var json = jQuery.parseJSON(data);
                    //console.log(json)

                    let newJson = {
                        draw: json.data.draw,
                        recordsFiltered: json.data.recordsFiltered,
                        recordsTotal: json.data.recordsTotal,
                        data: []
                    }
                    let rows = [];
                    vue.lengthMenu = json.data.data.length;
                    for (let i = 0, lei = json.data.data.length; i < lei; i++) {

                        let row = {};
                        let id = "";

                        let objId = {
                            DistributorPartId: json.data.data[i].DistributorPartId,
                            name: "DistributorPartId",
                            type: "text",
                            value: {
                                display: json.data.data[i].DistributorPartId,
                                filter: json.data.data[i].DistributorPartId,
                                sort: json.data.data[i].DistributorPartId
                            }
                        };

                        id = "col___DistributorPartId";
                        row[id] = objId;


                        objId = {
                            col___AvailableQuantity: json.data.data[i].AvailableQuantity,
                            name: "AvailableQuantity",
                            type: "text",
                            value: {
                                display: json.data.data[i].AvailableQuantity,
                                filter: json.data.data[i].AvailableQuantity,
                                sort: json.data.data[i].AvailableQuantity
                            }
                        };

                        id = "col___AvailableQuantity";
                        row[id] = objId;

                        objId = {
                            Description: json.data.data[i].Description,
                            name: "Description",
                            type: "text",
                            value: {
                                display: json.data.data[i].Description,
                                filter: json.data.data[i].Description,
                                sort: json.data.data[i].Description
                            }
                        };

                        id = "col___Description";
                        row[id] = objId;

                        objId = {
                            DistributorKey: json.data.data[i].DistributorKey,
                            name: "DistributorKey",
                            type: "text",
                            value: {
                                display: json.data.data[i].DistributorKey,
                                filter: json.data.data[i].DistributorKey,
                                sort: json.data.data[i].DistributorKey
                            }
                        };

                        id = "col___DistributorKey";
                        row[id] = objId;

                        objId = {
                            DistributorName: json.data.data[i].DistributorName,
                            name: "DistributorName",
                            type: "text",
                            value: {
                                display: json.data.data[i].DistributorName,
                                filter: json.data.data[i].DistributorName,
                                sort: json.data.data[i].DistributorName
                            }
                        };

                        id = "col___DistributorName";
                        row[id] = objId;

                        objId = {
                            DistributorPartId: json.data.data[i].DistributorPartId,
                            name: "DistributorPartId",
                            type: "text",
                            value: {
                                display: json.data.data[i].DistributorPartId,
                                filter: json.data.data[i].DistributorPartId,
                                sort: json.data.data[i].DistributorPartId
                            }
                        };

                        id = "col___DistributorPartId";
                        row[id] = objId;

                        objId = {
                            DistributorPartNumber: json.data.data[i].DistributorPartNumber,
                            name: "DistributorPartNumber",
                            type: "text",
                            value: {
                                display: json.data.data[i].DistributorPartNumber,
                                filter: json.data.data[i].DistributorPartNumber,
                                sort: json.data.data[i].DistributorPartNumber
                            }
                        };

                        id = "col___DistributorPartNumber";
                        row[id] = objId;

                        objId = {
                            DtasheetUrl: json.data.data[i].DtasheetUrl,
                            name: "DtasheetUrl",
                            type: "text",
                            value: {
                                display: json.data.data[i].DtasheetUrl,
                                filter: json.data.data[i].DtasheetUrl,
                                sort: json.data.data[i].DtasheetUrl
                            }
                        };

                        id = "col___DtasheetUrl";
                        row[id] = objId;

                        objId = {
                            ImageUrl: json.data.data[i].ImageUrl,
                            name: "ImageUrl",
                            type: "text",
                            value: {
                                display: json.data.data[i].ImageUrl,
                                filter: json.data.data[i].ImageUrl,
                                sort: json.data.data[i].ImageUrl
                            }
                        };

                        id = "col___ImageUrl";
                        row[id] = objId;

                        objId = {
                            IsROHSCompliant: json.data.data[i].IsROHSCompliant,
                            name: "IsROHSCompliant",
                            type: "text",
                            value: {
                                display: json.data.data[i].IsROHSCompliant,
                                filter: json.data.data[i].IsROHSCompliant,
                                sort: json.data.data[i].IsROHSCompliant
                            }
                        };

                        id = "col___IsROHSCompliant";
                        row[id] = objId;

                        objId = {
                            LeadDays: json.data.data[i].v,
                            name: "LeadDays",
                            type: "text",
                            value: {
                                display: json.data.data[i].LeadDays,
                                filter: json.data.data[i].LeadDays,
                                sort: json.data.data[i].LeadDays
                            }
                        };

                        id = "col___LeadDays";
                        row[id] = objId;

                        objId = {
                            LifecycleStatus: json.data.data[i].LifecycleStatus,
                            name: "LifecycleStatus",
                            type: "text",
                            value: {
                                display: json.data.data[i].LifecycleStatus,
                                filter: json.data.data[i].LifecycleStatus,
                                sort: json.data.data[i].LifecycleStatus
                            }
                        };

                        id = "col___LifecycleStatus";
                        row[id] = objId;

                        objId = {
                            ManufacturerName: json.data.data[i].ManufacturerName,
                            name: "ManufacturerName",
                            type: "text",
                            value: {
                                display: json.data.data[i].ManufacturerName,
                                filter: json.data.data[i].ManufacturerName,
                                sort: json.data.data[i].ManufacturerName
                            }
                        };

                        id = "col___ManufacturerName";
                        row[id] = objId;

                        objId = {
                            ManufacturerPartNumber: json.data.data[i].ManufacturerPartNumber,
                            name: "ManufacturerPartNumber",
                            type: "text",
                            value: {
                                display: json.data.data[i].ManufacturerPartNumber,
                                filter: json.data.data[i].ManufacturerPartNumber,
                                sort: json.data.data[i].ManufacturerPartNumber
                            }
                        };

                        id = "col___ManufacturerPartNumber";
                        row[id] = objId;

                        objId = {
                            ProductDetailUrl: json.data.data[i].ProductDetailUrl,
                            name: "ProductDetailUrl",
                            type: "text",
                            value: {
                                display: json.data.data[i].ProductDetailUrl,
                                filter: json.data.data[i].ProductDetailUrl,
                                sort: json.data.data[i].ProductDetailUrl
                            }
                        };

                        id = "col___ProductDetailUrl";
                        row[id] = objId;

                        objId = {
                            EOL: json.data.data[i].EOL,
                            name: "EOL",
                            type: "text",
                            value: {
                                display: json.data.data[i].EOL,
                                filter: json.data.data[i].EOL,
                                sort: json.data.data[i].EOL
                            }
                        };

                        id = "col___EOL";
                        row[id] = objId;

                        objId = {
                            EOS: json.data.data[i].EOS,
                            name: "EOS",
                            type: "text",
                            value: {
                                display: json.data.data[i].EOS,
                                filter: json.data.data[i].EOS,
                                sort: json.data.data[i].EOS
                            }
                        };

                        id = "col___EOS";
                        row[id] = objId;

                        // objId = {
                        //     TempMax: json.data.data[i].TempMax,
                        //     name: "TempMax",
                        //     type: "text",
                        //     value: {
                        //         display: json.data.data[i].TempMax,
                        //         filter: json.data.data[i].TempMax,
                        //         sort: json.data.data[i].TempMax
                        //     }
                        // };

                        // id = "col___TempMax";
                        // row[id] = objId;

                        // objId = {
                        //     TempMin: json.data.data[i].TempMin,
                        //     name: "TempMin",
                        //     type: "text",
                        //     value: {
                        //         display: json.data.data[i].TempMin,
                        //         filter: json.data.data[i].TempMin,
                        //         sort: json.data.data[i].TempMin
                        //     }
                        // };

                        // id = "col___TempMin";
                        // row[id] = objId;



                        rows.push(row);
                    }


                    newJson.data = rows;

                    
                    return JSON.stringify(newJson);
                },

            }



            if ($.fn.dataTable.isDataTable('#place' + this._uid)) {
                this.mainTable.destroy();

            }

            this.mainTable = $('#place' + this._uid).DataTable(option);

            this.mainTable.column(0).visible(false);

            let el = document.getElementsByClassName("dataTables_processing")[0]

            if (this.isPlugin) {
                el.classList.add("processing-top-plugin");
            } else {
                el.classList.add("processing-top");
            }


            //search input change view
            var searchplace = document.getElementById("place" + this._uid + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }


            searchplace.firstChild.setAttribute("placeholder", "Enter search words")
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm" + " place" + this._uid);
            searchplace.firstChild.addEventListener("input", function (evt) {

                _vue.$store.dispatch("setFilteredData", evt.target.value);

            })
            let lengthplace = document.getElementById("place" + this._uid + "_length");

            if (lengthplace.firstChild.firstChild != null) {
                lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
            }

            var stepWait = 0;
            var waitInterval;
            $(".dataTables_filter ." + "place" + this._uid)
                .unbind()
                .bind('input', function (e) {
                    var item = $(this);
                    stepWait = 0;

                    if (!waitInterval) {
                        waitInterval = setInterval(function () {
                            
                            if (stepWait >= 3) {
                                clearInterval(waitInterval);
                                waitInterval = '';
                                let searchString = $(item).val();
                                _mainTable.search(searchString).draw();
                                stepWait = 0;
                            }
                            stepWait++;
                        }, 150);
                    }

                });

            let _mainTable = this.mainTable;
            this.mainTable
                .on('select', function (e, dt, type, indexes) {
                    var rowData = _mainTable.rows(indexes).data();


                    let obj = {
                        DistributorPartId: rowData[0].col___DistributorPartId.value.display,
                        ManufacturerName: rowData[0].col___ManufacturerName.value.display,
                        ManufacturerPartNumber: rowData[0].col___ManufacturerPartNumber.value.display,
                        DistributorName: rowData[0].col___DistributorName.value.display,
                        DistributorPartNumber: rowData[0].col___DistributorPartNumber.value.display,
                        DistributorKey: rowData[0].col___DistributorKey.value.display,
                        AvailableQuantity: rowData[0].col___AvailableQuantity.value.display,
                        LeadDays: rowData[0].col___LeadDays.value.display,
                        IsROHSCompliant: rowData[0].col___IsROHSCompliant.value.display,
                        DtasheetUrl: rowData[0].col___DtasheetUrl.value.display,
                        Description: rowData[0].col___Description.value.display,
                        ImageUrl: rowData[0].col___ImageUrl.value.display,
                        ProductDetailUrl: rowData[0].col___ProductDetailUrl.value.display,
                        LifecycleStatus: rowData[0].col___LifecycleStatus.value.display,
                        EOL: rowData[0].col___EOL.value.display,
                        EOS: rowData[0].col___EOS.value.display,
                        // TempMin: rowData[0].col___TempMin.value.display,
                        // TempMax: rowData[0].col___TempMax.value.display,
                    }


                    vue.$store.dispatch("setSelectedSearchedRows", obj)



                })
                .on('user-select', function (e, dt, type, cell, originalEvent) {
                    if ($(originalEvent.target).index() === 0) {
                        e.preventDefault();
                    }
                })
                .on('deselect', function (e, dt, type, indexes) {

                    vue.$store.dispatch("deleteSelectedSearchedRows");
                })
            // $('#place' + this._uid + ' tbody').on('dblclick', 'tr', function (e) {
            //     e.stopPropagation()
            //     var data = _mainTable.row(this).data();

            //     _vue.$store.dispatch("deleteAllSelectedRows");
            //     _vue.$store.dispatch("setSelectedRows", data);
            //     _vue.$parent.$parent.$parent.$parent.$parent.$parent.details();
            // });



        },
        // buildContextMenu() {


        //     var _vue = this;


        //     //context-menu
        //     var tableid = $("#place" + this._uid);

        //     $("#place" + this._uid + " tbody tr")
        //         .on("contextmenu", function (e) {

        //             let tr = $(this).closest('tr');
        //             let row = _vue.mainTable.row(tr);

        //             let data = row.data();

        //             _vue.contextMenu.row = data



        //             //methods in table component
        //             //var updateUser = _vue.updateUser;
        //             //var deleteUser = _vue.deleteUser;

        //             _vue.contextMenu.funcAction = function (_vue, action) {

        //                 //calling component methods depending on the context menu item clicked


        //                 if (action == "Details") {
        //                     _vue.$store.dispatch("deleteAllSelectedRows");
        //                     _vue.$store.dispatch("setSelectedRows", data);
        //                     _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.details();
        //                 }
        //                 // if (action == "Derive"){
        //                 //   _vue.$store.dispatch("deleteAllSelectedRows");
        //                 //   _vue.$store.dispatch("setSelectedRows", data);
        //                 //   _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.derive();
        //                 // }
        //                 // if (action == "Withdraw"){
        //                 //   _vue.$store.dispatch("deleteAllSelectedRows");
        //                 //   _vue.$store.dispatch("setSelectedRows", data);
        //                 //   _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.withdraw();
        //                 // }  

        //                 return true;
        //             }

        //             var height = tableid.height();

        //             var offsetX = tableid.offset().left;
        //             var offsetY = tableid.offset().top;

        //             var top = e.clientY - offsetY + 170;
        //             var left = e.clientX - offsetX + 10;


        //             $("#context-menu-" + _vue.name).css({
        //                 display: "block",
        //                 top: top,
        //                 left: left
        //             });
        //             return false; //blocks default Webbrowser right click menu
        //         })
        //         .on("click", function () {

        //             $("context-menu-" + _vue.name).hide();
        //         });

        //     $("#context-menu-" + _vue.name + " a").on("click", function () {

        //         $(this)
        //             .parent()
        //             .hide();
        //     });
        //     document.addEventListener('click', function (e) {
        //         let clickInside = e.target.closest("#context-menu-" + _vue.name);

        //         if (clickInside == null) {

        //             let contextMenu = document.getElementById("context-menu-" + _vue.name);
        //             if (contextMenu != null) {
        //                 contextMenu.setAttribute('style', 'display:none');
        //             }

        //         }
        //     });
        //     //context-menu
        // }


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.UsedMPNsTableComponent {
    table {
        font-size: 0.75rem;
        padding: 0px !important;

    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;
        //white-space: nowrap;
    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
        position: absolute;
        top: -15px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .processing-top {
        top: 50px;
    }

    .processing-top-plugin {
        //top: 120px;
    }

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .dataTables_length {
        margin-left: 20px;
        width: 200px;
        float: left;
    }

    .dataTables_length label {
        display: inline-flex;
    }

    .select-length {
        padding: 0.1rem;
        margin-left: 10px;
        margin-right: 10px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        //margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
        width: 350px;
        float: left;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .image-category {
        max-width: 40px;
        //border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;

    }

    .badge {
        margin-right: 1px;

        margin-bottom: 2px;
    }

    .badges {
        margin-top: 3px;
        margin-bottom: 2px;
    }

    .image-svg {
        max-width: 40px;
        //border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-right: 3px;
        margin-bottom: 3px;
        background-color: white;
        padding: 2px;
    }
    .image {
        max-width: 40px;
        //border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;
    }

    .imageSVG {
        max-width: 40px;
        //border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;
        padding: 5px;
    }
}</style>



// WEBPACK FOOTER //
// src/components/shared/UsedMPNsTableComponent.vue